<mat-icon class="table-icon font-medium"
          matTooltip="VIEW Member Overview"
          (click)="openMemberOverviewDialog(); $event.stopPropagation()">
  info
</mat-icon>
